__turbopack_context__.v({
  "header_save": "styles-module-scss-module__UGZOrW__header_save",
  "property_like_button": "styles-module-scss-module__UGZOrW__property_like_button",
  "property_like_button_header": "styles-module-scss-module__UGZOrW__property_like_button_header",
  "property_like_button_header_is_active": "styles-module-scss-module__UGZOrW__property_like_button_header_is_active",
  "property_like_button_is_active": "styles-module-scss-module__UGZOrW__property_like_button_is_active",
});
